import { Box, Typography } from '@mui/material';
import React from 'react';
import { bodySx, linkSx, LoginModalShell } from './LoginModalShell';

interface Auth0ExpiredProps {
  open: boolean;
  handleClose: () => void;
  message?: string;
}

const DEFAULT_MESSAGE = 'The link has expired.';

export const Auth0Expired: React.FC<Auth0ExpiredProps> = ({ open, handleClose, message }) => {
  const safeMessage = message === 'This URL can be used only once' ? message : DEFAULT_MESSAGE;
  return (
    <LoginModalShell
      open={open}
      onClose={handleClose}
      titleId='auth0-expired-title'
      descriptionId='auth0-expired-description'
      title='Password link already used'
    >
      <Typography variant='body_02' sx={bodySx}>
        <b>{safeMessage}</b>
        <br />
        <br />
        If you need assistance, please contact Karius at{' '}
        <Box component='a' href='tel:8664527487' sx={linkSx}>
          (866) 452-7487
        </Box>
        {' or '}
        <Box component='a' href='mailto:help@kariusdx.com' sx={linkSx}>
          help@kariusdx.com
        </Box>
        .
      </Typography>
    </LoginModalShell>
  );
};
